import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    TranslationOptions,
} from 'owa-outlook-service-options';

export default function isLanguageExcluded(languageTag: string): boolean {
    const options = getOptionsForFeature<TranslationOptions>(OwsOptionsFeatureType.Translation);
    return options.excludedLanguages.includes(languageTag);
}
